module.exports = __webpack_public_path__ + "static/media/r10.fda29c48.jpg";